import { jsonFetch } from "@/lib/helpers";
import { API_METHODS } from "../shared";
import { TASKS_URL } from "./api-url.constants";
import { TaskApiDTO } from "./dtos";
import { CreateTaskApiDTO } from "./dtos/create-task.api.dto";

export interface CreateTaskResponse {
  data: TaskApiDTO;
}

export const createTask = async (taskData: CreateTaskApiDTO): Promise<string> => {
  const response = await jsonFetch<CreateTaskResponse>(TASKS_URL, {
    method: API_METHODS.POST,
    body: JSON.stringify(taskData),
  });

  return response.data._id;
};
